
const FourColumRow = ({children}) => {
    return (
        <div className="flex flex-col sm:flex-row w-full gap-4">
            <div className="w-full sm:w-1/2">
              {children[0]}
            </div>
            <div className="w-full sm:w-1/2">
              {children[1]}
            </div>
            <div className="w-full sm:w-1/2">
              {children[2]}
            </div>
            <div className="w-full sm:w-1/2">
              {children[3]}
            </div>
          </div>
      )
}

export default FourColumRow;

